import { FaShoppingCart } from "react-icons/fa";
import { useTranslation } from "context/LanguageContext";
import { getStockPolicy } from "utils/stockPolicy";

export default function AddToCart({ product, handleOnclick, disabled = false }) {
  const { t } = useTranslation();
  const { canAddToCartByStock } = getStockPolicy(product);
  const isDisabled = disabled || !canAddToCartByStock;

  return (
    <button
      onClick={handleOnclick}
      disabled={isDisabled}
      className={`w-full py-3 rounded-lg font-semibold text-white flex items-center justify-center gap-2 transition-all text-sm ${
        !isDisabled
          ? "bg-blue-600 hover:bg-blue-700 active:scale-95"
          : "bg-gray-300 cursor-not-allowed"
      }`}
    >
      <FaShoppingCart className="w-4 h-4" />

      {canAddToCartByStock
        ? t("addtoCart")
        : t("outOfStock")}
    </button>
  );
}
